/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-09 12:09:03
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-11 09:21:30
 */

import { Button, Modal } from 'react-bootstrap';
import { messageBoxButtons, messageBoxButtonsCaptionDefault } from './../../constants';

import PropTypes from 'prop-types';
import React from 'react';
import styles from './MessageBox.scss';

const MessageBox = ({
  onCancel,
  onOk,
  onClose,
  show,
  text,
  buttons = messageBoxButtons.ok, // Default value for buttons
  buttonsCaption = [...Object.values(messageBoxButtonsCaptionDefault)], // Default value for buttonsCaption
  closeButton,
}) => {
  //const { onCancel, onOk, onClose, show, text, buttons, buttonsCaption, closeButton } = props;
  const cancelHandler = (e) => {
    e.stopPropagation();
    onCancel();
  };
  const okHandler = (e) => {
    e.stopPropagation();
    onOk();
  };
  const closeHandler = (e) => {
    e.stopPropagation();
    onClose();
  };
  const okButtonText =
    buttonsCaption && buttonsCaption.length > 0 ? buttonsCaption[0] : messageBoxButtonsCaptionDefault.ok;
  const cancelButtonText =
    buttonsCaption && buttonsCaption.length > 1 ? buttonsCaption[1] : messageBoxButtonsCaptionDefault.cancel;
  return (
    <>
      <Modal
        show={show}
        animation={false}
        className={styles['main-messagebox-dialog']}
        backdropClassName={styles['main-messagebox-backdrop']}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName={styles['main-messagebox']}
        centered={true}
        onHide={() => {}}>
        <Modal.Body className={styles['modal-body']}>
          <div className={styles['close-wrapper']}>
            {closeButton && (
              <Button className={styles['close-button']} onClick={closeHandler}>
                <span className={styles['close-button-text']}>×</span>
              </Button>
            )}
          </div>
          <div className={styles['content']}>{text}</div>
        </Modal.Body>
        <Modal.Footer className={styles['modal-footer']}>
          {buttons === messageBoxButtons.ok ? (
            <Button variant="primary" className={styles['ok']} onClick={okHandler}>
              {okButtonText}
            </Button>
          ) : (
            <>
              <Button variant="outline-primary" className={styles['cancel']} onClick={cancelHandler}>
                {cancelButtonText}
              </Button>
              <Button variant="primary" className={styles['ok']} onClick={okHandler}>
                {okButtonText}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

MessageBox.propTypes = {
  buttons: PropTypes.oneOf([...Object.values(messageBoxButtons)]),
  buttonsCaption: PropTypes.array,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onCancel: PropTypes.func,
  onOk: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
};
// MessageBox.defaultProps = {
//   buttons: messageBoxButtons.ok,
//   buttonsCaption: [...Object.values(messageBoxButtonsCaptionDefault)],
// };

export default MessageBox;
